import React from "react";
import { buildListingUrl } from "components/v2/Listings/ListingsRouterUrlHelper";
import modalStyle from "./../../ListingFullDisplay.module.css";

function index({
  descriptionStyle,
  listing,
  message,
  contactAgenceHandler,
  agence,
  t,
  lang,
  style,

  showNum,
  forContactModal,
  setShowNum,
  modalVisionDesk,
}: {
  descriptionStyle?: boolean;
  listing: any;
  message: any;
  contactAgenceHandler: any;
  agence: any;
  t: any;
  lang: any;
  showNum?: boolean;
  style?: any;

  forContactModal?: any;
  setShowNum?: any;
  modalVisionDesk?: any;
}) {
  return (
    <div
      className={`${
        descriptionStyle
          ? modalStyle.actionsDescription
          : modalStyle.actionsBasicInfosNew
      } ${modalVisionDesk ? modalStyle.actionsModalVisionDesk : ""} `}
      style={style}
    >
      {forContactModal ? null : (
        <button
          onClick={(e) => {
            e.preventDefault();
            contactAgenceHandler();
          }}
          className={modalStyle.contacterButtonNew}
        >
          <img
            className="whatsapp-svg"
            src={"https://images.agenz.ma/uploads/Message.svg"}
            alt="Message icon"
            width="18"
            height="14"
          ></img>
        </button>
      )}
      <button
        className={modalStyle.appelerNew}
        onClick={(e) => {
          setShowNum(true);
        }}
      >
        <a
          data-tracking="click"
          data-value="mobile-tel"
          data-slug={listing.slug}
          aria-label="Whatsapp"
          rel="noindex,nofollow, noreferrer"
          href={`tel:${
            listing.transaction_type == "Projets Neufs"
              ? "+212665250835"
              : listing.phone
              ? listing.phone
              : agence?.phoneEntreprise
              ? agence.phoneEntreprise
              : listing.agence
              ? listing.agence.phone
                ? listing.agence.phone
                : listing.agencePhone
              : listing.agencePhone
          }`}
        >
          <img
            className="whatsapp-svg"
            src={"https://images.agenz.ma/uploads/Appeler.svg"}
            alt="phone icon"
            width="18"
            height="18"
          ></img>{" "}
          {showNum ? (
            <span>
              {listing.transaction_type == "Projets Neufs"
                ? "+212665250835"
                : listing.phone
                ? listing.phone
                : agence?.phoneEntreprise
                ? agence.phoneEntreprise
                : listing.agence
                ? listing.agence.phone
                  ? listing.agence.phone
                  : listing.agencePhone
                : listing.agencePhone}
            </span>
          ) : (
            t("Appeler")
          )}
        </a>
      </button>

      <button
        className={`${modalStyle.whatsappNew}`}
        onClick={() => {
          if (window) {
            if (window.dataLayer) {
              window.dataLayer.push({
                event: "contact-whatsapp-test",
              });
            }
          }
        }}
      >
        <a
          data-tracking="click"
          data-value="listing-whatsapp"
          data-slug={listing.slug}
          aria-label="Whatsapp"
          target="_blank"
          rel="noreferrer nofollow noopener"
          href={`https://api.whatsapp.com/send?phone=${
            listing.transaction_type == "Projets Neufs"
              ? "+212665250835"
              : listing.phone
              ? listing.phone
              : listing?.agence?.phoneEntreprise
              ? listing?.agence.phoneEntreprise
              : listing.agence
              ? listing.agence.phone
                ? listing.agence.phone
                : listing.agencePhone
              : listing.agencePhone
          }&text=${message}%0ahttps://agenz.ma${buildListingUrl(
            listing,
            lang
          )}`}
        >
          <img
            className="whatsapp-svg"
            src={"https://images.agenz.ma/uploads/Whatsapp.svg"}
            alt="Whatsapp icon"
            width="18"
            height="18"
          ></img>{" "}
          {t("Whatsapp")}
        </a>
      </button>
    </div>
  );
}

export default index;
